import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {UserStatus} from '@gatewee/types/user';

@Pipe({
  name: 'userStatus',
  standalone: false,
})
export class UserStatusPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: UserStatus | string): string {
    return (
      this.translate.instant(`enums.userStatus.${value}`) ||
      this.translate.instant('common.unknown')
    );
  }
}
